export const NPM_CLIENT_INIT = `import { PromptSlate, SlateVariables } from "promptslate";

const client = new PromptSlate({
    apiKey: '<generated_api_key>'
});`;

export const NODE_FETCH_DATABLOCK = `const datablock = await client.getDatablock("<datablock_key>");`;

export const NODE_DATA_INGEST_TYPE = `const dataToIngest: SlateVariables[] = [
    {
        name: "<variable_name_one>",
        value: "<data_one>"
      },
      {
        name: "<variable_name_one>",
        value: "<data_two>"
      }
]`;

export const NODE_PASSING_INGEST_DATA = `const datablock = await client.getDatablock("<datablock_key>", dataToIngest);`;

export const PS_API_BASE_URL = `http://api.promptslate.com/api/v1`;
export const PS_GET_DATABLOCK_ENDPOINT = `/datablock/<datablock_key>`;

export const PS_VARIABLE_FORMAT = `{{psvar.<variable_name>}}`;
